define([
    'jquery'
], function ($) {
    'use strict';

    let $html,
        $nav,
        $btn_nav_toggle,
        $btn_nav_close;

    const close = function() {
        $html.removeClass('js-nav-open');
    }

    const onNavToggleClick = function (event) {
        event.preventDefault();

        if ($html.hasClass('js-nav-open')) {
            $html.removeClass('js-nav-open');
        } else {
            $html.addClass('js-nav-open');
        }
    };

    const onNavCloseClick = function (event) {
        event.preventDefault();
        $html.removeClass('js-nav-open');
    };

    const init = function () {
        $html = $('html');
        $nav = $('.nav');
        $btn_nav_toggle = $('.js-btn_nav_toggle');
        $btn_nav_close = $('.js-btn_nav_close');

        $btn_nav_toggle.off('click', onNavToggleClick);
        $btn_nav_toggle.on('click', onNavToggleClick);
        $btn_nav_close.off('click', onNavCloseClick);
        $btn_nav_close.on('click', onNavCloseClick);
    };

    return {
        init: init,
        close: close
    }
});